<template>
  <vue-ads-pagination
    :total-items="itemsCount"
    :items-per-page="4"
    :max-visible-pages="3"
    :page="page"
    class="pagination _mt-12 _px-sm-4"
    :loading="false"
    @page-change="pageChange"
    @range-change="rangeChange"
  >
    <template slot-scope="props">
      <div class="d-none vue-ads-pr-2 vue-ads-leading-loose">
        Items {{ props.start }} tot {{ props.end }} van de {{ props.total }}
      </div>
    </template>
    <template slot="buttons" slot-scope="props">
      <vue-ads-page-button
        class="pagination__arrow _mr-12 _mr-sm-auto"
        v-bind="props.buttons[0]"
        :html="arrowLeft"
        @page-change="page = props.buttons[0].page"
      />
      <div class="pagination__pages">
        <Page
          class="pagination__page"
          :class="{ pagination__page_current: button.active }"
          v-for="(button, key) in props.buttons"
          :key="key"
          v-bind="button"
          @page-change="page = button.page"
        />
      </div>
      <vue-ads-page-button
        class="pagination__arrow _ml-12 _ml-sm-auto"
        v-bind="props.buttons[props.buttons.length - 1]"
        :html="arrowRight"
        @page-change="page = props.buttons[props.buttons.length - 1].page"
      />
    </template>
  </vue-ads-pagination>
  <!-- <div class="pagination">
    <div class="pagination__arrow _mr-12">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 8H1M1 8L8 15M1 8L8 1"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="pagination__pages">
      <div class="pagination__page">1</div>
    </div>
    <div class="pagination__arrow _ml-12">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 8H15M15 8L8 1M15 8L8 15"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div> -->
</template>

<script>
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'
import Page from './Page.vue'

export default {
  name: 'Pagination',
  components: {
    VueAdsPagination,
    VueAdsPageButton,
    Page,
  },
  data: () => ({
    page: 0,
    arrowLeft:
      '<svg width="16" height="16"viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 8H1M1 8L8 15M1 8L8 1"stroke="white"stroke-width="2"stroke-linecap="round"stroke-linejoin="round"/></svg>',
    arrowRight:
      '<svg  width="16"  height="16"  viewBox="0 0 16 16"  fill="none"  xmlns="http://www.w3.org/2000/svg">  <path    d="M1 8H15M15 8L8 1M15 8L8 15"    stroke="white"    stroke-width="2"    stroke-linecap="round"    stroke-linejoin="round"  /></svg>',
  }),
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    itemsCount: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    pageChange(page) {
      this.page = page
    },

    rangeChange(start, end) {
      // console.log(start, end)
      this.$emit('rangeChange', start, end)
    },
  },
  computed: {},
  mounted() {
    if (this.$route.query && this.$route.query.page) {
      this.page = parseInt(this.$route.query.page - 1)
    }
  },
  watch: {
    page(newV, oldV) {
      if (
        oldV !== newV &&
        parseInt(this.$route.query.page) !== parseInt(newV) + 1
      ) {
        window.scroll(0, 0)
        this.$router.push({
          ...this.$route,
          query: { ...this.$route.query, page: parseInt(newV) + 1 },
        })
        // history.pushState(
        //   {},
        //   null,
        //   `${this.$route.path}?page=${parseInt(newV) + 1}`
        // )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  &__arrow {
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    background-color: color(grey-second);
    transition: 0.3s;
    border-radius: 16px;
    outline: none;
    cursor: pointer;

    &:hover {
      background-color: darken(color(grey-second), 10);
    }
  }

  &__pages {
    margin: 0 -8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__page {
    outline: none;
    cursor: pointer;
    border: none;
    padding: 0;
    background-color: transparent;
    margin: 0 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: color(grey-light);
    transition: 0.3s;

    &:hover:not(.pagination__page_current) {
      color: color(green-main);
    }

    &_current {
      color: color(dark);
    }
  }
}
</style>
<style>
.vue-ads-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.vue-ads-cursor-default:not(.pagination__arrow) {
  cursor: default !important;
}
</style>
